import * as actions from './constants';

export const ASSIGN_DATA = 'ASSIGN_DATA';
export const REMOVE_REQUEST = 'REMOVE_REQUEST';
export const ADD_NEW_REQUEST = 'ADD_NEW_REQUEST';

const initialState = {
  request: null
};

// eslint-disable-next-line default-param-last
export default function pendingRequestReducer(state = initialState, action) {
  switch (action.type) {
    case ASSIGN_DATA:
      return {
        ...state,
        request: action.payload.data
      };
    case REMOVE_REQUEST: {
      const removeId = action.payload;
      let newList = [];
      const removedIndex = state.request.findIndex((rl) => rl.id === removeId);
      if (removedIndex > -1) {
        newList = [
          ...state.request.slice(0, removedIndex),
          ...state.request.slice(removedIndex + 1)
        ];

        return {
          ...state,
          request: newList
        };
      }
      return {
        ...state,
        request: state.request
      };
    }

    case ADD_NEW_REQUEST: {
      return {
        ...state,
        request: state.request ? [action.payload, ...state.request] : [action.payload]
      };
    }
    case actions.RESET_STATE:
      return {
        request: null
      };
    default:
      return state;
  }
}
